module.exports = __webpack_public_path__ + "static/media/forbes.5927f69d.png";